import HomeLayout from "./HomeLayout";
import Banner from "../../components/Landing/Banner";
import Section from "../../components/Landing/Section";
import Button from "../../components/common/Button";

import {
  yojanaBannerItems,
  veerChandEligibility,
  veerChandDefinition,
  veerChandYojanaSections,
} from "../../config/homePageUtils";
import ActivitiesSection from "../../components/Landing/ActivitiesSection";
import SubsidyGrantsSection from "../../components/Landing/SubsidyGrantsSection";
import { MSY_WEBSITE_URL } from "../../config/apiConfig";
import { useState } from "react";
import YojanaSections from "../../components/Landing/YojanaSections";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";

const VeerChandYojana = () => {
  const { image, title, description, overview } =
    yojanaBannerItems.veerChandYojana;
  const [activeSection, setActiveSection] = useState("overview");
  const { language } = useLanguage();

  return (
    <HomeLayout>
      <Banner
        image={image}
        title={title}
        description={description}
        buttonUrl={MSY_WEBSITE_URL}
        language={language}
      />
      <YojanaSections
        options={veerChandYojanaSections}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        language={language}
      >
        {/* Overview Section */}
        {activeSection === "overview" && (
          <Section
            id="overview"
            title={language ? "संक्षिप्त विवरण" : "Overview"}
            openByDefault={true}
          >
            <p>{language ? overview.hi : overview.en}</p>
          </Section>
        )}

        {/* Applicability Section */}
        {activeSection === "applicability" && (
          <Section
            id="applicability"
            title={language ? "प्रभाव क्षेत्र" : "Applicability"}
          >
            <p>
              {language
                ? "यह योजना पूरे उत्तराखंड में लागू की जाएगी।"
                : "The scheme will be implemented throughout Uttarakhand."}
            </p>
          </Section>
        )}

        {/* Activities Covered Section */}
        {activeSection === "activities-covered" && (
          <ActivitiesSection language={language} />
        )}

        {/* Eligibility Section */}
        {activeSection === "eligibility" && (
          <Section
            id="eligibility"
            title={language ? "योग्यता" : "Eligibility"}
          >
            <ul className="list-unstyled space-y-3">
              {veerChandEligibility.map((item, idx) => (
                <li key={idx} className="d-flex align-items-start">
                  <span className="text-[#018f9b] me-2 mt-1">●</span>
                  <span>{language ? item.hi : item.en}</span>
                </li>
              ))}
            </ul>
          </Section>
        )}

        {/* Definition Section */}
        {activeSection === "definition" && (
          <Section
            id="definition"
            title={
              language ? "बेरोजगारी की परिभाषा" : "Definition of Unemployment"
            }
          >
            <ul className="list-unstyled space-y-3">
              {veerChandDefinition.map((item, idx) => (
                <li key={idx} className="d-flex align-items-start">
                  <span className="text-[#018f9b] me-2 mt-1">●</span>
                  <span>{language ? item.hi : item.en}</span>
                </li>
              ))}
            </ul>
          </Section>
        )}

        {/* Subsidy & Grants Section */}
        {activeSection === "subsidy-grants" && (
          <SubsidyGrantsSection language={language} />
        )}

        {/* Loan Provisions */}
        {activeSection === "loan-provisions" && (
          <Section
            id="loan-provisions"
            title={language ? "लोन नियम" : "Loan Provisions"}
          >
            <p>
              {language
                ? "चयनित आवेदकों को राष्ट्रीयकृत बैंकों और ग्रामीण बैंकों के माध्यम से बैंकों द्वारा निर्धारित प्रचलित ब्याज दरों पर वित्तीय सहायता प्रदान की जाएगी।"
                : "Selected applicants will be provided financial assistance through nationalized banks and rural banks at the prevailing interest rates set by banks."}
            </p>
          </Section>
        )}

        {/* Implementation Section */}
        {activeSection === "implementation" && (
          <Section
            id="implementation"
            title={language ? "कार्यान्वयन" : "Implementation"}
          >
            <p>
              {language
                ? "वीर चंद सिंह गढ़वाली पर्यटन स्वरोजगार योजना वित्तीय वर्ष 2022-23 से एमएसवाई पोर्टल के माध्यम से ऑनलाइन संचालित हो रही है।"
                : "The Veer Chand Singh Garhwali Tourism Self-Employment Scheme is operational online through the MSY Portal from the financial year 2022-23."}
            </p>
          </Section>
        )}
      </YojanaSections>
      <section className="px-4 py-10 md:px-20 lg:px-32">
        <div className="max-w-7xl mx-auto px-0">
          <div className="inline-flex items-center">
            <Button
              className="ml-2 text-lg text-white bg-[#018f9b] px-6 py-3 rounded-full hover:opacity-90 transition"
              onClick={() =>
                window.open(MSY_WEBSITE_URL, "_blank", "noopener,noreferrer")
              }
            >
              {language ? "अभी अप्लाई करें" : "Apply Now/ Login"} →
            </Button>
          </div>
        </div>
      </section>
    </HomeLayout>
  );
};

export default VeerChandYojana;
